export function getSrcSet(url: string, sizes: number[]) {
	const { origin, pathname, searchParams } = new URL(url)

	searchParams.delete('w')
	searchParams.delete('h')

	const src = `${origin}${pathname}?${searchParams.toString()}`
	return sizes.map((size) => `${src}&w=${size} ${size}w`).join(', ')
}
